import styled from 'styled-components';
import { mediaMin } from '@spa/shared/theme';

export const CarouselContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
  overflow: hidden;
  width: 100%;

  &:active {
    outline: none;
    border: none;
  }

  &:focus {
    outline: 0;
  }

  ${mediaMin.smallBreakpoint`
    width: 100%;
    position: fixed;
    bottom: ${props => props.theme.space(17)};
  `};
`;

export const InnerCarouselContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  overflow: hidden;
  width: 100%;
  height: 100%;

  ${mediaMin.smallBreakpoint`
    height: 310px;
  `};
`;

export const CarouselWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-wrap: nowrap;
`;

export const CarouselItem = styled.div`
  position: relative;
  background: ${props => props.theme.carousel.background};
  height: ${props => props.theme.space(100)};
  width: ${props => props.width + 'px' || '100%'};
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  margin: 0 10px;
  border-radius: 4px;

  > a {
    width: 100%;

    h3 {
      width: 442px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  ${mediaMin.smallBreakpoint`
    height: ${props => props.theme.space(71)};

    > a {
      height: 100%;
      margin-bottom: 0;

      > div:first-child {
        min-height: 150px;
      }

      .offer__badges {
        span {
          max-width: calc(100% / 3);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  `};
`;

export const Navigator = styled.div`
  position: absolute;
  z-index: 2;
  top: calc(150px - 19px);
  width: 38px;
  height: 38px;
  display: flex;
  background-color: ${props => props.theme.carousel.background};
  border-radius: 19px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;

  svg {
    opacity: 0.6;
    margin: auto;
  }
`;

export const LeftNavigator = styled(Navigator)`
  left: ${props => `${props.navigatorPos}px` || '25%'};

  svg {
    transform: rotate(180deg);
  }
`;

export const RightNavigator = styled(Navigator)`
  right: ${props => `${props.navigatorPos}px` || '25%'};
`;
